/* unplugin-vue-components disabled */
import {stringToFile} from 'utils/utils'
import MdTable from './md-table'

export default {
  components: {MdTable},
  data: () => ({
    mount_modal: false,
  }),
  methods: {
    afterEnter(){
      const table = document.body.querySelector('#modals .md-expanded')
      const content = table.querySelector('.content')
      const barx = table.querySelector('.barx')
      content.append(barx)
    },
    open(){
      this.mount_modal = true
      this.$nextTick(() => this.$refs.modal.open())
      
    },
    close(){
      this.$refs.modal.close()
    },
    prepareDomNode(){
      const dom = this.$refs.table.getTable().cloneNode(true)
      Array.from(dom.querySelectorAll('span[url]')).forEach(span => {
        const domain = $utils.str.getRootDomain(span.getAttribute('url'))
        const num = span.querySelector('sup').innerText
        span.innerHTML = ` [${num}](${domain})`
      })
      return dom
    },
    downloadCSV(){
      const table = this.prepareDomNode()
      const csv = $utils.dom.domTableToCsv(table)
      const title = this.$refs.title.textContent
      stringToFile(
        csv, 
        title ? `${$utils.str.truncate(title, 50)}.csv` : 'table.csv', 
        'data:text/csv;charset=utf-8'
      )
    },
    async copyText(){
      const table = this.prepareDomNode()
      const str = $utils.dom.domTableToText(table)
      await $utils.copyText(str)
    }
  }
}
